import storage from '../common/utils/storage'

export default (): string | null => storage.getItem('token')
